const acceptDefault = [`image/jpeg`, 'image/png', 'image/jpg', 'image/bmp'];

/** setIndex 0 = คู่แรก; 1+ = ชุดเพิ่ม (mobileBrandId2, …) */
export const getWarrantyAddBrandModelFieldNames = (setIndex) => {
  if (setIndex === 0) {
    return { brand: 'mobileBrandId', model: 'mobileModelName' };
  }
  const n = setIndex + 1;
  return { brand: `mobileBrandId${n}`, model: `mobileModelName${n}` };
};

/**
 * ชุดยี่ห้อ + รุ่น (setIndex 0 = คู่แรก ใช้ key เดิม; 1,2 = คู่เพิ่ม)
 * @param {{ required?: boolean }} [fieldOptions] — หน้า edit ใช้ required เฉพาะชุดแรก (default: ทุกชุด required)
 */
export const getWarrantyAddBrandModelFields = (setIndex, mobileBrandOptions, fieldOptions = {}) => {
  const { required = true } = fieldOptions;
  const span = 24;
  const { brand, model } = getWarrantyAddBrandModelFieldNames(setIndex);
  const setSuffix = setIndex === 0 ? '' : ` (ชุด ${setIndex + 1})`;
  const requiredRules = required ? { required: true } : undefined;
  return [
    {
      name: brand,
      label: `ยี่ห้อ${setSuffix}`,
      type: 'DROPDOWN',
      placeholder: '',
      properties: {
        options: mobileBrandOptions || [],
      },
      span,
      rules: requiredRules,
      style: { width: '100%', height: '100%', minHeight: '32px' },
    },
    {
      name: model,
      label: `รุ่น${setSuffix}`,
      type: 'INPUT',
      placeholder: '',
      span,
      rules: requiredRules,
      style: { width: '100%', height: '100%', minHeight: '32px' },
    },
  ];
};

export const FORM_WARRANTY_ADD_PRODUCT_LEADING = ({ onEnter, mobileBrandOptions } = {}) => {
  const span = 24;
  return [
    {
      name: 'barcode',
      label: 'Barcode',
      type: 'INPUT_BARCODE',
      placeholder: '',
      span,
      rules: {
        required: true,
        pattern: /^[0-9]{9}$/,
      },
      maxLength: 9,
      onEnter,
    },
    {
      name: 'productNameTh',
      label: 'ชื่อสินค้า',
      type: 'INPUT',
      placeholder: '',
      span,
      rules: {
        required: true,
      },
      style: { width: '100%', height: '100%', minHeight: '32px' },
      disabled: true,
    },
    {
      name: 'productTypeName',
      label: 'ประเภทของสินค้า',
      type: 'INPUT',
      placeholder: '',
      span,
      rules: {
        required: true,
      },
      disabled: true,
    },
    ...getWarrantyAddBrandModelFields(0, mobileBrandOptions),
  ];
};

export const FORM_WARRANTY_ADD_PRODUCT_TRAILING = ({
  channelBuyOptions,
  accept = acceptDefault,
} = {}) => {
  const span = 24;
  return [
    {
      name: 'channelBuyId',
      label: 'ช่องทางการซื้อขาย',
      type: 'DROPDOWN',
      placeholder: '',
      properties: {
        options: channelBuyOptions || [],
      },
      span,
      rules: {
        required: true,
      },
    },
    {
      name: 'infoPicture',
      label: 'ชนิดรูปภาพที่ต้องการ (.png, .jpg, .jpeg, .bmp)',
      type: 'TEXT',
      span,
    },
    {
      name: 'invImage',
      label: 'รูปใบเสร็จ ',
      type: 'UPLOAD',
      accept: accept.join(','),
      listType: 'picture-card',
      span: 12,
      maxCount: 1,
      rules: {
        required: true,
      },
    },
    {
      name: 'packageImage',
      label: 'รูปสินค้า',
      type: 'UPLOAD',
      accept: accept.join(','),
      listType: 'picture-card',
      span: 12,
      maxCount: 1,
      rules: {
        required: true,
      },
    },
  ];
};

export const FORM_USER_REGISTRATION_WARRANTY = ({ onEnter }) => {
  return [
    {
      name: 'telephone',
      label: 'เบอร์ติดต่อ (กรอกเบอร์ติดต่อแล้วกด Enter)',
      type: 'INPUT_PHONE',
      placeholder: '',
      span: 12,
      rules: {
        required: true,
        pattern: /^[0-9]{10}$/,
      },
      maxLength: 10,
      onEnter,
    },
    {
      name: 'fullName',
      label: 'ชื่อ-นามสกุล',
      type: 'INPUT',
      placeholder: '',
      span: 12,
      rules: {
        required: true,
      },
    },
  ];
};

/**
 * ฟอร์มสินค้าแบบเดิม (ยี่ห้อ/รุ่น 1 ชุด) สำหรับเคสอื่นที่อ้างอิง
 */
export const FORM_PRODUCT_REGISTRATION_WARRANTY = ({
  onEnter,
  mobileBrandOptions,
  channelBuyOptions,
}) => {
  const accept = acceptDefault;
  return [
    ...FORM_WARRANTY_ADD_PRODUCT_LEADING({ onEnter, mobileBrandOptions }),
    ...FORM_WARRANTY_ADD_PRODUCT_TRAILING({ channelBuyOptions, accept }),
  ];
};
